<template>
  <b-modal
    :id="`FlagMissingClassifiers-${item.uuid}`"
    size="lg"
    header-class="d-block pb-1"
    cancel-variant="tertiary"
    ok-title="Send"
    @ok="sendClassifiers"
  >
    <template v-slot:modal-header>
      <h5 class="modal-title mb-3">
        Topics Training
      </h5>
      <p>
        This feature will help refine our topic logic for more precise matches in the future.<br>
        Please select one or more topics related to the publisher's article.
      </p>
    </template>
    <b-row>
      <b-col
        v-for="classifier in classifiers"
        :key="classifier"
        class="col-lg-3 classifier"
      >
        <b-form-checkbox
          :id="classifier"
          v-model="selectedClassifiers"
          :value="classifier"
        >
          <span>{{ classifier }}</span>
        </b-form-checkbox>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>

import { mapActions } from 'vuex';
import * as campaignMatchesTypes from '@/modules/campaignMatches/store/types';

export default {
  name: 'BrandsafetyClassifiersModal',
  props: {
    classifiers: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedClassifiers: [],
    };
  },
  methods: {
    ...mapActions('campaignMatches', [
      campaignMatchesTypes.UPDATE_BRANDSAFETY_CLASSIFIERS,
    ]),
    sendClassifiers() {
      if (this.selectedClassifiers.length > 0) {
        this.$emit('updateClassifiers', { item: this.item, labels: this.selectedClassifiers });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.classifier {
  height: 45px;
  line-height: 1;
}
</style>
